<template>
  <div
    class="hospitalContactBtn"
    :class="{
      '-horizontal': isHorizontal,
      '-vertical': isVertical,
      '-sideNav': position === 'side'
    }"
  >
    <p v-if="paidFlg && outputTitle" class="hospitalContactBtn_ttl">
      {{ outputTitle }}
    </p>

    <div class="hospitalContactBtn_inquiry" v-if="paidFlg">
      <Button
        label="見学申込み"
        :href="visitApplicationUrl"
        :handleClick="() => $router.push(visitApplicationUrl)"
        secondary
      />
      <Button
        label="資料請求"
        :href="documentRequestUrl"
        :handleClick="() => $router.push(documentRequestUrl)"
        lightgray
      />
    </div>
    <div class="hospitalContactBtn_fav">
      <FavoriteButton
        :label="isFavorite ? 'お気に入り登録済み' : 'お気に入りに保存'"
        :is-active="isFavorite"
        :handleClick="clickFavorite"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from '@vue/runtime-core'
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import FavoriteButton from '@/components/elements/FavoriteButton.vue'
import { ActionHistory } from '@/types/StoreState'

export default defineComponent({
  name: 'hospitalContactBtn',

  components: {
    Button,
    FavoriteButton
  },

  props: {
    type: {
      type: String as PropType<'default' | 'latter'>,
      default: 'default'
    },
    position: {
      type: String as PropType<'main' | 'side'>,
      default: 'main'
    },
    id: {
      type: Number,
      require: true
    },
    sTrainingId: {
      type: Number,
      default: 0
    },
    sTrainingName: {
      type: String,
      default: ''
    },
    paidFlg: {
      type: Boolean,
      default: false
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    isVertical: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { emit }) {
    const store = useStore()

    const outputTitle = computed(() => {
      if (props.type === 'default') return '初期研修への申し込み'
      if (props.sTrainingName)
        return `専門研修「${props.sTrainingName}」への申し込み`
      return ''
    })

    const visitApplicationUrl = computed(() => {
      return props.type === 'default'
        ? `/visit_application/${props.id}/input`
        : `/visit_application_latter/${props.sTrainingId}/input`
    })

    const documentRequestUrl = computed(() => {
      return props.type === 'default'
        ? `/document_request/${props.id}/input`
        : `/document_request_latter/${props.sTrainingId}/input`
    })

    const isFavorite = computed(() => {
      if (!store.state.isLogin) return false

      if (props.type === 'default') {
        return store.state.userInfo.favorite_history.some(
          (el: ActionHistory) => el.hospital_id === Number(props.id)
        )
      }
      if (props.type === 'latter') {
        return store.state.userInfo.s_favorite_history.some(
          (el: ActionHistory) => el.s_training_id === Number(props.sTrainingId)
        )
      }
      return false
    })

    const clickFavorite = () => {
      if (props.type === 'default') return emit('click-favorite')

      if (props.type === 'latter') {
        if (isFavorite.value) {
          store.dispatch('removeFavorite', {
            id: Number(props.id),
            sId: Number(props.sTrainingId)
          })
        } else {
          store.dispatch('addFavorite', {
            id: Number(props.id),
            sId: Number(props.sTrainingId)
          })
        }
      }
    }

    return {
      outputTitle,
      visitApplicationUrl,
      documentRequestUrl,
      isFavorite,
      clickFavorite
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hospitalContactBtn {
  background-color: var.$color-other-bg;
  padding: 20px 16px 24px;
  margin-left: -16px;
  margin-right: -16px;

  &_ttl {
    margin-bottom: 12px;
    font-weight: 700;
    line-height: 1.5;
    text-align: center;
  }

  &_inquiry {
    display: flex;
    justify-content: space-between;

    * {
      max-width: 49%;
      margin-left: 0;
      margin-right: 0;
    }
  }

  &_fav {
    width: 215px;
    margin: 15px auto 10px;
  }

  &.-sideNav {
    margin: 0 -20px -15px;
    padding: 20px;
  }

  &.-horizontal {
    display: flex;
    .hospitalContactBtn_inquiry {
      * {
        width: 152px;
        max-width: none;
      }
      * + * {
        margin-left: 16px;
      }
    }
    .hospitalContactBtn_fav {
      margin: 0 0 0 16px;
    }
  }

  &.-vertical {
    .hospitalContactBtn_inquiry {
      display: block;
      * {
        max-width: 100%;
        margin-bottom: 15px;
      }
    }
    .hospitalContactBtn_fav {
      width: 100%;
    }
  }
}
</style>
